import React, {Fragment} from "react";
import {withRouter} from "react-router-dom";
import SFXButtonComponent from "../components/SFXButtonComponent";
import CardBatchService from "../services/card/stock/CardBatchService";
import ToastHelper from "../utils/ToastHelper";
import LoadingSpinnerComponent from "../components/LoadingSpinnerComponent";
import MainPanelComponent from "../components/MainPanelComponent";
import {Row} from "react-bootstrap";
import SidePanelComponent from "../components/SidePanelComponent";
import DataTableComponent from "../components/DataTableComponent";
import BatchBankCard from "../domain/card/batch/BatchBankCard";
import BankCardAssignmentComponent from "../components/BankCardAssignmentComponent";
import "../scss/CustomerIndex.css"

const VIEW_STATE_VIEW = "view";
const VIEW_STATE_ASSIGN = "assign";

class CardBatchView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            bankCards: [],
            barcodes: [],
            viewState: VIEW_STATE_VIEW
        };
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        CardBatchService.retrieve(this.props.batchId).then(response => {
            if (response.id) {
                this.setState({
                    loading: false,
                    cardBatch: response,
                    bankCards: response.bankCards,
                    barcodes: this.getBarcodes(response.bankCards)
                });
            } else {
                ToastHelper.error(response);
            }
        });
    }

    getBarcodes(bankCards) {
        let barcodes = [];
        bankCards.forEach(bankCard => {
            barcodes.push(bankCard.barcode);
        });

        return barcodes;
    }

    onAssignClick() {
        this.setState({
            viewState: VIEW_STATE_ASSIGN
        });
    }

    btnBackClick() {
        this.setState({
            viewState: VIEW_STATE_VIEW
        });
    }

    getBatchDetailsText() {
        let numberOfCardsAssignedToAgents = "Assigned To Agents: " + this.state.cardBatch.numberOfCardsAssignedToAgents;
        numberOfCardsAssignedToAgents += "/" + this.state.cardBatch.batchSize;
        let numberOfCardsAssignedToCustomers = "Allocated To Customers: " + this.state.cardBatch.numberOfCardsAssignedToCustomers;
        numberOfCardsAssignedToCustomers += "/" + this.state.cardBatch.batchSize;

        return <Fragment>
            {numberOfCardsAssignedToAgents}
            <p style={{marginTop: "5px"}}>
                {numberOfCardsAssignedToCustomers}
            </p>
        </Fragment>;
    }

    render() {

        if (this.state.loading) {
            return <LoadingSpinnerComponent/>
        }

        return <Fragment>
            <Row>
                {this.state.viewState === VIEW_STATE_VIEW && this.renderCardBatchDetails()}
                {this.state.viewState === VIEW_STATE_ASSIGN && this.renderBankCardAssignmentComponent()}
            </Row>
        </Fragment>
    }

    renderCardBatchDetails() {
        return <Fragment>
            <MainPanelComponent>
                <DataTableComponent
                    tableColumnConfig={BatchBankCard.getColumnConfig()}
                    tableData={this.state.bankCards}
                    search={true}
                    pagination={true}
                    createCustomButtonGroup={() => {
                        return <Fragment>
                            {this.getBatchDetailsText()}
                        </Fragment>
                    }}
                />

            </MainPanelComponent>

            <SidePanelComponent>
                <Fragment>
                    <SFXButtonComponent onClick={this.onAssignClick.bind(this)} className={"btn btn-primary"}
                                        style={{width: '100%', marginBottom: '5px'}}>
                        Assign Cards
                    </SFXButtonComponent>
                    {'   '}
                    <SFXButtonComponent onClick={this.props.btnBackClick} className={"btn btn-sfx-secondary"}
                                        style={{width: '100%', marginBottom: '5px'}}>
                        Back
                    </SFXButtonComponent>
                </Fragment>
            </SidePanelComponent>
        </Fragment>
    }

    renderBankCardAssignmentComponent() {
        return <BankCardAssignmentComponent
            batchId={this.props.batchId}
            bankCards={this.state.bankCards}
            barcodes={this.state.barcodes}
            btnBackClick={this.btnBackClick.bind(this)}
            loadData={this.loadData.bind(this)}
        />
    }
}

export default withRouter(CardBatchView);
